import {NgModule, Optional, SkipSelf} from '@angular/core';
import {TranslocoModule} from "@jsverse/transloco";
import {RouterModule} from "@angular/router";


import {CookiePosService} from "@core/services/cookie-pos.service";
import {LocalStorageService} from "@core/services/storage.service";
import {CommonModule} from "@angular/common";
import {NgxPermissionsModule, NgxPermissionsService} from "ngx-permissions";
import {NgxToastRootModule} from '@core/libs/ngx-toast';
import {TransLocoProviders} from '@core/libs/transloco';
import {HttpInterceptorProviders} from '@core/interceptors';


@NgModule({
  declarations: [],
  imports: [
    RouterModule,
    CommonModule,
    TranslocoModule,
    NgxToastRootModule,
    NgxPermissionsModule.forRoot({
      permissionsIsolate: true,
      rolesIsolate: true
    }),
  ],
  providers: [
    NgxPermissionsService,
    ...HttpInterceptorProviders,
    TransLocoProviders,
    CookiePosService,
    LocalStorageService,
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule onloaded');
    }
  }
}
